const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'action_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_ACTIONS':
      return {
        ...state,
        data: action.payload
      }
    case 'SORT_ACTIONS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_ACTIONS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_ACTIONS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_ACTION':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.action_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/actions.js